class EmailSignup extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector(".email-signup__button");
    this.emailInput = this.querySelector('input[type="email"]');
    this.popup = null;

    if (this.form) {
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    // Show the popup immediately
    this.showSuccessPopup();
  }

  showSuccessPopup() {
    // Remove any existing popup
    if (this.popup) {
      this.popup.remove();
    }

    // Create popup element
    this.popup = document.createElement("div");
    this.popup.className = "email-signup-popup";
    this.popup.innerHTML = `
      <div class="email-signup-popup__content">
        <button class="email-signup-popup__close" aria-label="Close popup">
          <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
            <path d="M11.414 10l4.293-4.293a1 1 0 1 0-1.414-1.414L10 8.586 5.707 4.293a1 1 0 0 0-1.414 1.414L8.586 10l-4.293 4.293a1 1 0 1 0 1.414 1.414L10 11.414l4.293 4.293a1 1 0 0 0 1.414-1.414L11.414 10z" fill="currentColor"/>
          </svg>
        </button>
        <svg class="email-signup-popup__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" height="48" width="48">
          <path fill="white" d="M0 8.40234V40.4023H48V8.40234H0ZM44.875 9.96484L24.1563 22.6836L4.3125 9.96484H44.875ZM2.59375 37.5586V12.1211L24.1563 25.9648L45.4375 11.1523V38.8398L2.59375 37.5586Z"></path>
        </svg>
        <h3 class="email-signup-popup__heading">Thank you for joining our newsletter</h3>
        <p class="email-signup-popup__text">We've sent a message directly into your inbox, we'll try to keep it aesthetic from now on.</p>
        <div class="email-signup-popup__timer">
          <div class="email-signup-popup__timer-bar"></div>
        </div>
      </div>
    `;

    // Add popup to body
    document.body.appendChild(this.popup);

    // Add close button functionality
    const closeButton = this.popup.querySelector(".email-signup-popup__close");
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.closePopup();
      });
    }

    // Auto close after 10 seconds
    setTimeout(() => {
      this.closePopup();
    }, 10000);

    // Start timer animation
    const timerBar = this.popup.querySelector(".email-signup-popup__timer-bar");
    if (timerBar) {
      setTimeout(() => {
        timerBar.style.width = "0%";
      }, 10);
    }
  }

  showError(errors) {
    // Remove any existing error messages
    const existingError = this.querySelector(".email-signup__message--error");
    if (existingError) {
      existingError.remove();
    }

    // Create error message element
    const errorDiv = document.createElement("div");
    errorDiv.className = "email-signup__message email-signup__message--error";
    errorDiv.innerHTML = `
      <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" class="icon-error">
        <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2" fill="none"/>
        <path d="M10 6v4m0 4h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      ${errors}
    `;

    this.form.appendChild(errorDiv);
  }

  closePopup() {
    if (this.popup) {
      this.popup.classList.add("email-signup-popup--closing");
      setTimeout(() => {
        if (this.popup) {
          this.popup.remove();
          this.popup = null;
        }
        // Submit the form once the popup has fully closed
        if (this.form) {
          this.form.submit();
        }
      }, 300);
    }
  }
}

customElements.define("email-signup", EmailSignup);
